import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  viewChild,
  type InputSignalWithTransform,
  type Signal,
  type TemplateRef,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ModalService } from "@core/services/modal-service/modal.service";
import { PwaInstallService } from "@shared/services/pwa/pwa-install.service";
import { ButtonDirective } from "@shared/directives/button.directive";

@Component({
  selector: "app-install-app-button",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./install-app-button.component.html",
  imports: [ButtonDirective, TranslateModule],
})
export class InstallAppButtonComponent {
  private readonly modalService: ModalService = inject(ModalService);
  protected readonly pwaInstall: PwaInstallService = inject(PwaInstallService);

  readonly fullWidth: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });

  private readonly iosGuide: Signal<TemplateRef<unknown>> = viewChild.required<TemplateRef<unknown>>("iosGuide");

  protected install(): void {
    if (this.pwaInstall.state() === "prompt") {
      void this.pwaInstall.install();
      return;
    }

    this.modalService.open({
      component: this.iosGuide(),
      ngbOptions: { ariaLabelledBy: "pwa-ios-guide-title", backdrop: true, keyboard: true },
    });
  }
}
